import { useDispatch, useSelector } from "react-redux"
import { Link } from "react-router-dom"
import validator from "validator"
import { startRegister } from "../../actions/auth"

import { removeError, setError } from "../../actions/ui"
import { useForm } from "../../hooks/useForm"

const RegisterScreen = () => {

    const dispatch = useDispatch()
    const { msgError } = useSelector(state => state.ui)

    const [formValues, handleInputChange, reset] = useForm({
        name: 'jose',
        email: 'josediaz@gmail.com',
        password: '123456',
        password2: '123456'
    })

    const { name, email, password, password2 } = formValues

    const handleRegister = (e) => {
        e.preventDefault()

        if (isFormValid()) {
            dispatch(startRegister(email, password, name))
        }
    }

    const isFormValid = () => {
        if (validator.isEmpty(name)) {
            dispatch(setError('Name is required'))
            return false
        } else if (!validator.isEmail(email)) {
            dispatch(setError('Email is not valid'))
            return false
        } else if (password !== password2 || password.length < 5) {
            dispatch(setError('Password must be at least 5 characters long and match each other.'))
            return false
        }

        dispatch(removeError())

        return true
    }

    return (
        <>
            <h3 className="auth__title mb-5">Register</h3>

            <form 
                className="animate__animated animate__fadeIn"
                onSubmit={handleRegister}
            >
                { msgError &&
                    <div className="auth__alert-error">
                        { msgError }
                    </div>
                }

                <input
                    type="text"
                    placeholder="Name"
                    name="name"
                    className="auth__input"
                    autoComplete="off"
                    value={name}
                    onChange={handleInputChange}
                />

                <input
                    type="email"
                    placeholder="Email"
                    name="email"
                    className="auth__input"
                    autoComplete="off"
                    value={email}
                    onChange={handleInputChange}
                />

                <input
                    type="password"
                    placeholder="Password"
                    name="password"
                    className="auth__input"
                    value={password}
                    onChange={handleInputChange}
                />

                <input
                    type="password"
                    placeholder="Confirm password"
                    name="password2"
                    className="auth__input"
                    value={password2}
                    onChange={handleInputChange}
                />

                <button
                    type="submit"
                    className="btn btn-primary btn-full mt-1 mb-5"
                >
                    Register
                </button>

                <Link to="/auth/login" className="links">
                    Already registered?
                </Link>
            </form>
        </>
    )
}

export default RegisterScreen